import { render, staticRenderFns } from "./PageCloudImportEditSettings.vue?vue&type=template&id=627be5c8&scoped=true&"
import script from "./PageCloudImportEditSettings.vue?vue&type=script&lang=js&"
export * from "./PageCloudImportEditSettings.vue?vue&type=script&lang=js&"
import style0 from "./PageCloudImportEditSettings.vue?vue&type=style&index=0&id=627be5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627be5c8",
  null
  
)

export default component.exports